import React, { Component } from "react";
import loadForm from "core-module/hoc/loadForm";

const wizardStepWithForm = function(path, InnerComponent) {
  const FormLoaded = loadForm(path, InnerComponent);
  return class extends Component {
    render() {
      return (
        <FormLoaded
          {...this.props}
          setIsValidated={isValidated => {
            this.isValidated = isValidated;
          }}
          setSendState={sendState => {
            this.sendState = sendState;
          }}
          pathids={this.props.allStates.pathids}
        />
      );
    }
  };
};

export default wizardStepWithForm;
